// extracted by mini-css-extract-plugin
export default {"holder":"NowPlaying_holder__xFUvE","nowplaying":"NowPlaying_nowplaying__ZbIUG"};